import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ListViewModule } from '@ui/shared/feature-list';

import type { PreventionListItemModel } from './definitions/prevention-list-item.model';
import { PreventionListListItemComponent } from './components/prevention-list-list-item.component';
import { FilterMapperComponent } from '@ui/shared/ui-filter';
import { BaseAppComponent } from '@ui/shared/feature-config';

@Component({
    imports: [AsyncPipe, ListViewModule, FilterMapperComponent],
    selector: 'ui-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends BaseAppComponent<PreventionListItemModel> {
    constructor() {
        super(PreventionListListItemComponent);
    }
}
